import req from 'utils/req';
import {
  ChatMessageResponse,
  PersonalizedOfferRequestMessageResponse,
  RescheduleRequestMessageResponse,
  ShareExperienceMessageResponse,
  ShareLocationMessageResponse,
  ShareProfileMessageResponse
} from 'model/MessageTypes/Responses';
import {useMutation} from '@tanstack/react-query';
import MessagesClient from 'flux/clients/messages';

export function fetchLastMessages({ page, pageSize }) {
  const params = new URLSearchParams();
  params.set('include', 'contact');
  params.append('include', 'booking');
  params.set('page', page);
  params.set('per_page', pageSize);

  return req(`${URL_API_HOST}/api/v3/messages?${params.toString()}`).get();
}

export function fetchContact({ id }) {
  const params = new URLSearchParams();
  params.set('include', 'contact');
  params.append('include', 'booking');

  return req(`${URL_API_HOST}/api/v3/messages/${id}?${params.toString()}`).get();
}

export function fetchActionsRequired({ page, pageSize }) {
  const params = new URLSearchParams();
  params.set('include', 'contact');
  params.append('include', 'booking');
  params.set('page', page);
  params.set('per_page', pageSize);

  return req(`${URL_API_HOST}/api/v3/messages/actionable?${params.toString()}`).get();
}

export function fetchChat({ contactId, from, size }) {
  return req(`${URL_API_HOST}/api/v2/chat/${contactId}/${from}/${size}`).get();
}

export function postMessage({ message, to }): Promise<ChatMessageResponse> {
  return req(`${URL_API_HOST}/api/v1/messages`).post( {
    body: message,
    to,
  });
}
export function postShareProfile({ to, account_id }): Promise<ShareProfileMessageResponse> {
  return req(`${URL_API_HOST}/api/v1/messages`).post( {
    to,
    account_id,
    body: '',
    requestType: 'SharedProfile'
  });
}

export function postSharedExperience({ to, experienceId }): Promise<ShareExperienceMessageResponse> {
  return req(`${URL_API_HOST}/api/v1/messages`).post({
    to,
    experience_id: experienceId,
    body: '',
    requestType: 'SharedExperience'
  });
}

export function postSharedLocation({ to, location }): Promise<ShareLocationMessageResponse> {
  return req(`${URL_API_HOST}/api/v1/messages`).post({
    to,
    location,
    body: '',
    requestType: 'SharedLocation'
  });
}

export function markMessagesAsRead({ contactId }) {
  return req(`${URL_API_HOST}/api/v3/messages/readall/${contactId}`).post();
}

export function rejectUserRequest({ requestId }): Promise<PersonalizedOfferRequestMessageResponse> {
  return req(`${URL_API_HOST}/api/v1/userrequest/${requestId}`).delete();
}

export function requestReschedule({ bookingId, message }): Promise<RescheduleRequestMessageResponse> {
  return req(`${URL_API_HOST}/api/v1/userrequest/`)
    .post({ change: 'CHANGEDATETIMEREQUEST', message, trip_id: bookingId })
}

export const useSendOfferRequest = ({ onSuccess, onError, onMutate }) => {
  return useMutation((data: any) => MessagesClient.sendOfferRequest(data),
    {
      retry: 0,
      onSuccess: onSuccess,
      onError: onError,
      onMutate: onMutate
    });
}
